export default class Rezept {
    public rezept_id: number | null = null;
    public bezeichnung: string | null = null;
    public verabreichung: string | null = null;
    public parameter1: string | null = null;
    public parameter2: string | null = null;
    public parameter3: string | null = null;
    public parameter4: string | null = null;
    public parameter5: string | null = null;
    public parameter6: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Rezept>) {
        Object.assign(this, data);
    }
}
